import React from 'react';
// import { useHistory } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import firebase from '../../constants/firebase'


const SignOutButton = () => {
    const navigate = useNavigate()

    function handleSignOut() {
        firebase.auth().signOut()
        navigate('../auth/signin')
        return null
    }

    return (
        <button type="button" onClick={handleSignOut}>
            Sign Out
        </button>
    )
}

export default SignOutButton